/**
 * External dependencies.
 */
import { isEmpty, has } from 'lodash';

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */

function styling( props, selector = '' ) {
	const { attributes } = props;
	const { blockAdvanceOptions, blockClientId } = attributes;
	selector = selector ? selector : `.gutenify-section-${ blockClientId } .gutenify-button-link`;

	let css = '';

	let styleNormal = '';
	styleNormal += `${ has( blockAdvanceOptions, 'textColor' ) && ! isEmpty( blockAdvanceOptions.textColor ) ? `color: ${ blockAdvanceOptions.textColor };` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'backgroundColor' ) && ! isEmpty( blockAdvanceOptions.backgroundColor ) ? `background: ${ blockAdvanceOptions.backgroundColor };` : '' }`;
	if ( has( blockAdvanceOptions, 'backgroundGradient' ) && ! isEmpty( blockAdvanceOptions.backgroundGradient ) ) {
		styleNormal += `background: ${ blockAdvanceOptions.backgroundGradient };`;
	}
	styleNormal += `${ has( blockAdvanceOptions, 'borderColor' ) && ! isEmpty( blockAdvanceOptions.borderColor ) ? `border-color: ${ blockAdvanceOptions.borderColor };` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'borderWidth' ) && blockAdvanceOptions.borderWidth > 0 ? `border-width: ${ blockAdvanceOptions.borderWidth }px;` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'borderWidth' ) && blockAdvanceOptions.borderWidth > 0 ? `border-style: solid;` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'borderRadius' ) && ! isEmpty( blockAdvanceOptions.borderRadius ) ? `border-radius: ${ blockAdvanceOptions.borderRadius };` : '' }`;

	if ( styleNormal ) {
		css += `${ selector } { ${ styleNormal } }`;
	}

	let styleHover = '';
	styleHover += `${ has( blockAdvanceOptions, 'hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.hoverTextColor ) ? `color: ${ blockAdvanceOptions.hoverTextColor };` : '' }`;
	styleHover += `${ has( blockAdvanceOptions, 'hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundColor ) ? `background: ${ blockAdvanceOptions.hoverBackgroundColor };` : '' }`;
	if ( has( blockAdvanceOptions, 'hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundGradient ) ) {
		styleHover += `background: ${ blockAdvanceOptions.hoverBackgroundGradient };`;
	}
	styleHover += `${ has( blockAdvanceOptions, 'hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.hoverBorderColor };` : '' }`;

	if ( styleHover ) {
		css += `${ selector }:hover { ${ styleHover } }`;
	}

	return applyFilters( 'gutenify--button--inline-styles', css, props );
}
export default styling;
